import React from 'react';
import { render } from 'react-dom';
import { inViewport, logger } from 'packages';
import { ProviderWithGlobalStore } from 'tradera-state/configure-store';
import { ConnectedFooterLocalizationLink } from 'components/footer/footer-localization-link';

const renderFooterLocalizationLink = selector => {
    try {
        inViewport(selector, target => {
            render(
                <ProviderWithGlobalStore>
                    <ConnectedFooterLocalizationLink />
                </ProviderWithGlobalStore>,
                target
            );
        });
    } catch (e) {
        logger(e);
    }
    return null;
};

export const bootFooterLocalization = () => {
    renderFooterLocalizationLink('#footer-localization-link');
};
